import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'

import SignIn from '../../components/SignIn/SignIn'
import LogIn from '../../components/LogIn/LogIn'
import Card from '@material-ui/core/Card'
import { useSnackbar } from 'notistack'

//Redux
import allActions from '../../redux/actions/user'
//Material UI
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import LockOpenIcon from '@material-ui/icons/LockOpen'
import CreateIcon from '@material-ui/icons/Create'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  card: {
    display: 'flex',
    margin: '16px',
    width: '380px',
    boxShadow: '0px 3px 11px 0px rgba(0,0,0,0.75)',
    borderRadius: 10,
    flexDirection: 'column',
  },

  tab: {
    [theme.breakpoints.up('330')]: {
      height: '48px',
      minHeight: '48px',
    },

  }
}))

const childrenStyles = makeStyles(theme => ({
  shadow: {
    boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.75)',
  },
  containerButton: {
    marginTop: '16px',
    gap: '8px',
    display: 'flex',
    flexDirection: 'column',
  },
  select: {
    textAlign: 'inherit'
  }
}))

export default function LogSignIn(props) {

  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()
  const cStyles = childrenStyles()
  const history = useHistory()
  const state = useSelector(state => state)
  

  useEffect(() => {
    if(state.loggedIn) history.push('/')

  }, [state.loggedIn])

  //Si il y a un token de verification d'inscription
  useEffect(() => {
    async function getToken() {
      const token = new URLSearchParams(props.location.search).get('token')
      if (token) {
        //Appel API pour la validation de l'inscription
        const result = await allActions.fetchPostAPI('api/users/check-email/' + token, {}, dispatch)

        //Si la requête n'a pas fonctionnné une erreur est affiché
        if (result.err) {
          enqueueSnackbar(`Erreur de validation: ${result.err}`, { variant: 'error' })
          return
        }

        const { res, json } = result
        //Si le serveur retourne une erreur elle est affiché
        if (!res.ok) {
          enqueueSnackbar(`Erreur de validation: ${json.message}`, { variant: 'error' })
          return
        }
        enqueueSnackbar(`Votre inscription est validée`, { variant: 'success' })
      }
    }
    getToken()

  }, [])

  const [tab, setTab] = useState(0)
  const [info, setInfo] = useState({})

  const handleChange = (event, newValue) => setTab(newValue)

  return (
    <div className={classes.root} id="login-signin">
      <Card className={classes.card}>
        <Tabs className={classes.tab} value={tab} onChange={handleChange} indicatorColor="primary" variant="fullWidth" >
          <Tab className={classes.tab} icon={<LockOpenIcon />} label="Connexion" />
          <Tab className={classes.tab} icon={<CreateIcon />} label="inscription" />
        </Tabs>

        {tab === 0 && <LogIn styles={cStyles} setTab={setTab} setInfo={setInfo}/>}
        {tab === 1 && <SignIn styles={cStyles} info={info}/>}

      </Card>
    </div >
  )
}
